module.exports = __webpack_public_path__ + "040aa5a433038e5fab46ece36804bd7f.png";